<template>
    <v-app>
        <v-navigation-drawer width="419" :app="!isMobile" permanent v-if="toggle || !isMobile">
            <v-list-item two-line class="pl-12 green white--text nav-top" style="height: 90px" :to="{name : 'Profile'}" @click="toggle = false">
                <v-list-item-avatar :size="isMobile ? 30 : 66">
                    <v-img :src="HOME_USER.avatar || require('@/../public/images/Avatar.png')"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{ `${HOME_USER.name} ${HOME_USER.sur_name}` }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list class="py-0">
                <v-list-item class="pl-12 py-3" :to="{name : 'Blog'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-home'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.home")}}</v-list-item-title>
                </v-list-item>

                <v-divider class="green mb-2"></v-divider>

                <v-list-item class="pl-12" :to="{name : 'Subjects'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-subjects'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.subjects")}}</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'Homework'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-homework'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.homework")}}</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'Teams'}" @click="toggle = false" v-if="hasRole('teacher')">
                    <v-list-item-icon>
                        <svg v-svg="'icon-teams'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.teams")}}</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'Students'}" @click="toggle = false" v-if="hasRole('teacher')">
                    <v-list-item-icon>
                        <svg v-svg="'icon-students'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.students")}}</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'Quizzes'}" @click="toggle = false" v-if="hasRole('student')">
                    <v-list-item-icon>
                        <svg v-svg="'icon-quizzes'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.quizzes")}}</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'Results'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-results'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.results")}}</v-list-item-title>
                </v-list-item>

<!--                <v-list-item class="pl-12" :to="{name : 'Help'}" @click="toggle = false">-->
<!--                    <v-list-item-icon>-->
<!--                        <svg v-svg="'icon-help'" size="24"></svg>-->
<!--                    </v-list-item-icon>-->

<!--                    <v-list-item-title>{{$t("home_layout.help")}}</v-list-item-title>-->
<!--                </v-list-item>-->

                <v-divider class="green mt-2"></v-divider>

                <v-list-item class="pl-12 py-3" @click="logout()">
                    <v-list-item-icon>
                        <svg v-svg="'icon-logout'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>{{$t("home_layout.log_out")}}</v-list-item-title>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <p class="ml-12 mb-5 font-weight-bold black--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</p>
            </template>
        </v-navigation-drawer>

        <v-app-bar height="90" app color="white">
            <v-app-bar-nav-icon class="ml-3" :to="{name : 'Home'}">
                <v-img :src="require('@/../public/images/icons/TCO.png')"/>
            </v-app-bar-nav-icon>
            <v-spacer v-if="isMobile"></v-spacer>
            <h2 class="green--text font-weight-bold pl-3">
                {{APP_NAME.toUpperCase()}} - {{$t(`home_layout.${HOME_USER.role_label}`)}} {{$t('home_layout.dashboard')}}
            </h2>
            <v-spacer v-if="isMobile"></v-spacer>
            <v-app-bar-nav-icon class="mr-3" v-if="isMobile" @click="toggle = !toggle">
                <svg v-svg="'icon-open-nav'" size="28 21" v-if="!toggle"></svg>
                <svg v-svg="'icon-close-nav'" size="28 21" v-else></svg>
            </v-app-bar-nav-icon>
        </v-app-bar>

        <v-main v-show="!toggle">
            <v-container fluid>
                <slot></slot>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data: () => ({ isMobile: false, toggle: false }),

        mounted() {
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true });
        },

        beforeDestroy() {
            if (typeof window === 'undefined') return;
            window.removeEventListener('resize', this.onResize, { passive: true });
        },

        methods: {
            logout() {
                this.$store.dispatch('LOGOUT_HOME');
                this.$router.push({name : 'Login'});
            },

            onResize() {
                this.isMobile = window.innerWidth < 1264
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/layouts/index";
</style>